import unorm from "unorm";

let timer;
export const debounce = (callback, delay) => {
  // eslint-disable-next-line func-names
  return function () {
    // eslint-disable-next-line prefer-rest-params
    const args = arguments;
    const context = this;
    clearTimeout(timer);
    timer = setTimeout(() => {
      callback.apply(context, args);
    }, delay);
  };
};

export const queryPageKey = "p";

export const eventKey = "Enter";

export const frenchNameRegex = /[a-zA-Z0-9 àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ]/g;
export const emailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/g;
export const immatOldSivRegex = /^([0-9]{3}[ ][a-zA-Z]{3}|[0-9]{4}[ ][a-zA-Z]{2})[ ][0-9]{2}$/g;
export const immatSivRegex = /^(W|[a-zA-Z]{2})[-][0-9]{3}[-][a-zA-Z]{2}$/g;
export const immatCycloRegex = /^[a-zA-Z]{1,2}[ ][0-9]{2,3}[ ][a-zA-Z]$/g;
export const permisRegex = /^\w{1,15}$/g;
export const latitudeRegex = /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/g;
export const longitudeRegex = /^[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/g;
export const inseeCodeRegex = /^[a-zA-Z0-9]{1,5}$/g;
export const postalCodeRegex = /^(?:0[1-9]|[1-8]\d|9[0-8])\d{3}$/g;
export const departementCodeRegex = /^([02][1-9]|2[aAbB]|[1345678][0-9]|9[012345]|97[123456]|98[6789])$/g;
export const phoneRegex = /^[0-9]+$/;
export const siteRegex = /^\S+$/;

export const checkFrenchNameRules = ({ key, length }) => !!(key && key.match(frenchNameRegex) && key.length <= length);
export const checkEmailRules = ({ key }) => !!(key && key.match(emailRegex) && key.length <= 80);
export const checkMessageLength = ({ key }) => !(!key || key.length > 2000);

export const DMYToDate = (date) => {
  const [day, month, year] = date.split("/");
  return new Date(year, month - 1, day);
};

export const numericFormatDate = ({ date, lang }) =>
  new Date(date).toLocaleDateString(`${lang.toLowerCase()}-${lang}`, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

export const fullNumericFormatDate = ({ date, lang }) =>
  new Date(date).toLocaleDateString(`${lang.toLowerCase()}-${lang}`, {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  });

export const digitFormatDate = ({ date, lang }) =>
  new Date(date).toLocaleDateString(`${lang.toLowerCase()}-${lang}`, {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
  });

export const alphaNumericFormatDate = (date) => {
  return new Date(date).toLocaleDateString("FR-fr", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};

export const longFormatDate = ({ date, lang }) => {
  return new Date(date).toLocaleDateString(`${lang.toLowerCase()}-${lang}`, {
    weekday: "long",
    month: "long",
    day: "numeric",
  });
};

export const shortFormatDate = ({ date, lang }) => {
  return new Date(date).toLocaleDateString(`${lang.toLowerCase()}-${lang}`, {
    weekday: "short",
    month: "short",
    day: "numeric",
  });
};

export const fullFormatDate = ({ date, lang }) => {
  return new Date(date).toLocaleDateString(`${lang.toLowerCase()}-${lang}`, {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const timeFormat = ({ date, lang }) => {
  const newDate = new Date(date).toLocaleTimeString(`${lang.toLowerCase()}-${lang}`, {
    hour: "2-digit",
    minute: "2-digit",
  });
  return lang === "FR" ? newDate.replace(":", "h") : newDate;
};

export const formatDateToLocalTimezone = (date) => {
  const currentDate = new Date(date);
  const offset = currentDate.getTimezoneOffset();
  const newDate = new Date(currentDate.getTime() - offset * 60 * 1000);
  return newDate.toISOString().replace("Z", "");
};

export const dateNowFormatted = new Date().toISOString().split("T")[0];

export const getTranslateIndex = (value) => (value > 1 ? 1 : 0);

export const getSiteName = (s) => {
  switch (s) {
    case "ANTS":
      return "ANTS";
    case "PASSEPORT_CNI":
      return "Carte d'identité et passeport";
    case "IMMAT":
      return "Immatriculation";
    case "PERMIS":
      return "Permis de conduire";
    case "PHA":
      return "Professionnel de l'automobile";
    case "AUTO_ECOLE":
      return "Auto-Ecole et CSSR";
    case "MAIRIE":
      return "Mairie";
    default:
      return "";
  }
};

export const getSitePrefix = (s) => {
  switch (s) {
    case "PASSEPORT_CNI":
      return "passeport.";
    case "IMMAT":
      return "immatriculation.";
    case "PERMIS":
      return "permisdeconduire.";
    case "PHA":
      return "pha.";
    case "AUTO_ECOLE":
      return "autoecole.";
    case "MAIRIE":
      return "mairie.";
    default:
      return "";
  }
};

export const removeProperties = (object, properties) => {
  const newObject = Object.keys(object)
    .filter((key) => !properties.includes(key))
    .reduce(
      (filtered, key) => ({
        ...filtered,
        [key]: object[key],
      }),
      {},
    );
  if (newObject.children) {
    newObject.children = newObject.children.map((c) => removeProperties(c, properties));
  }
  return newObject;
};

export const getFileExtension = (name) => (name?.match(/.*(\.[a-zA-Z]+)/i) || [])[1] || "";

export const getFileNameWithoutExtension = (name) => (name?.match(/(.*)\.[a-zA-Z]+/i) || [])[1] || "";

export const getSize = ({ size, unity = 0 }) => {
  const unityArray = ["octets", "ko", "Mo", "Go"];
  if (typeof size === "number") {
    if (size >= 1024) {
      const newSize = size / 1024;
      const newUnity = unity + 1;
      return getSize({ size: newSize, unity: newUnity });
    }
    return `${size?.toString().split(".")[0]} ${unityArray[unity]}`;
  }
  return size;
};

export const stringToSnakeCaseString = (s = "") =>
  `${unorm
    .nfd(s.toLowerCase())
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[\s']/g, "_")
    .replace(/-{2,}/g, "_")
    .replace(/-/g, "_")
    .replace(/[^a-z0-9_./~~]/g, "")
    .replace(/_$/g, "")}`;

export const normalizePhoneNumber = (phoneNumber) =>
  phoneNumber
    .replace(/[ .\-/]+/g, "")
    .padStart(10, "0")
    .replace(/(\d{2})(?=\d)/g, "$1 ");
